import { render, staticRenderFns } from "./OrganismVamosPaLaCalleActividadesGrid.vue?vue&type=template&id=004c376b&scoped=true"
import script from "./OrganismVamosPaLaCalleActividadesGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganismVamosPaLaCalleActividadesGrid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c376b",
  null
  
)

export default component.exports